module.exports = __webpack_public_path__ + "img/banner.656c92f0.png";